<!--
 * @description:
 * @author: 06455
 * @date: 2023/12/18 10:53
-->
<template>
  <div></div>
</template>

<script>
export default {
  name: 'Common',
  methods: {
    // 加法
    add (...numbers) {
      let sum = 0
      for (const number of numbers) {
        sum += Number(number || 0)
      }
      return this.fix2Num(sum)
    },
    // 减法
    subtract (...numbers) {
      if (numbers.length === 0) {
        return 0; // 如果没有传入参数，则返回0
      }
      let result = numbers[0] || 0; // 将第一个参数作为初始值
      for (let i = 1; i < numbers.length; i++) {
        result -= Number(numbers[i] || 0); // 依次减去后续参数的值
      }
      return this.fix2Num(result);
    },
    // 乘法
    multiply (...numbers) {
      if (numbers.length === 0) {
        return 0; // 如果没有传入参数，则返回0
      }
      let result = 1; // 将初始值设置为1，因为任何数乘以1都是它自身
      for (const number of numbers) {
        result *= Number(number || 0); // 依次乘以后续参数的值
      }
      return this.fix2Num(result);
    },
    // 除法
    divide (...numbers) {
      if (numbers.length === 0) {
        return 0; // 如果没有传入参数，则返回0
      }
      let result = numbers[0]; // 将第一个参数作为初始值
      for (let i = 1; i < numbers.length; i++) {
        if (numbers[i] === 0) {
          return NaN; // 如果有任何一个参数为0，则返回NaN（非数字）
        }
        result /= Number(numbers[i]); // 依次除以后续参数的值
      }
      return this.fix2Num(result);
    }
  }
}
</script>

<style scoped>

</style>
